import { useState } from "react";
import "./Navbar.scss";
import Sidebar from "../Sidebar/Sidebar";
import { faHome, faList } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const [showSidebar, setShowSidebar] = useState(false);
  const location = useLocation();
  const links = [
    {
      name: "Home",
      path: "/",
      icon: faHome,
    },
    {
      name: "Receipes",
      path: "/receipes",
      icon: faList,
    },
  ];
  function closeSidebar() {
    setShowSidebar(false);
  }
  return (
    <div>
      <div className="navbar container">
        <Link to="/" className="logo">
          NK <span>FoodHub</span>
        </Link>
        <div className="nav-links">
          {links.map((links) => (
            <Link
              className={location.pathname === links.path ? "active" : " "}
              to={links.path}
              key={links.name}
            >
              {links.name}
            </Link>
          ))}
        </div>
        <div
          onClick={() => setShowSidebar(!showSidebar)}
          className={showSidebar ? "sidebar-btn active" : "sidebar-btn "}
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
      {showSidebar && <Sidebar close={closeSidebar} links={links} />}
    </div>
  );
}

export default Navbar;
